const testimonial = [
  {
    name: "John M",
    position: "Personal Injury Lawyer",
    quote:
      "Nobel Flow streamlined our entire workflow. Managing Accident Benefits claims has never been this easy!",
    image: require("../../assets/images/testimonial1.png"),
    rating: 5,
  },
  {
    name: "David R.",
    position: "Legal Associate",
    quote:
      "Their AI tools saved us hours of manual work every week. Highly recommended!",
    image: require("../../assets/images/testimonial2.png"),
    rating: 4,
  },
  {
    name: "Priya Desai",
    position: "Legal Consultant, Brampton",
    quote:
      "From document management to analytics, the platform handles everything beautifully. A must-have for any legal firm.",
    image: require("../../assets/images/testimonial3.png"),
    rating: 5,
  },
];

export default testimonial;
